import styled from 'styled-components'

export const EvaluationsTableWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spaces.min3};
`
